<template lang="pug">
div
  download-trial-modal

  watermark-modal

  headroom.site_header(v-if="showNav", :upTolerance='0', :downTolerance='0')
    .nav__section
      router-link.logo(to="/")
        img(src="https://cdn.flixel.com/static/static-web/logos/logo__white.png")
    .nav__section.nav__desktop
      ul.drop-menu
        li.nav__item
          h1 Products
          ul.sub-menu.nav__width--products
            li.underline
              router-link(to="/products/mac/cinemagraph-pro/") Cinemagraph Pro
                span  macOS
            li.underline
              router-link(to="/products/ios/cinemagraph-pro/") Cinemagraph Pro
                span  iOS
            li.underline
              router-link(to="/products/ios/blendeo/") Blendeo
                span  iOS
            li.underline
              router-link(to="/products/mac/persecond/") Persecond
                span  macOS
            li.underline
              a(href="https://itunes.apple.com/ca/app/flixel-tv/id1043381618?mt=8") Flixel TV
                span  tvOS
            li.underline
              router-link(to="/products/hosting/") Cinemagraph Hosting
        li.nav__item
          router-link(to="/products/pricing/")
            h1 Pricing
        li.nav__item
          router-link(to="/studios/")
            h1 Services
        li.nav__item
          h1 Company
          ul.sub-menu
            li.underline
              router-link(to="/company/") About Flixel
            li
              a(href="http://blog.flixel.com/contact/") Contact
        li.nav__item
          h1 Learn
          ul.sub-menu
            li.underline
              router-link(to="/tutorials/") Tutorials
            li.underline
              router-link(to="/case-studies/") Case Studies
            li.underline
              a(href="http://support.flixel.com/") Help Center
            li
              a(href="http://forums.flixel.com") Forums
        li.nav__item
          a(href="http://blog.flixel.com/")
            h1 Blog
        li.nav__item
          router-link(to="/cinemagraphs/")
            h1 Gallery
    .nav__section#sign-in
      ul.drop-menu
        li(v-show="!profile")
          router-link(to="/login/") Sign In
        li.profile#profile(v-if="profile")
          img.avatar(:src="profile.avatar")
          ul.sub-menu#profileMenu
            li.underline
              h2 {{ account.username }}
              h3(@click='GoTo("Profile", account.username)') View profile >
            li.underline
              h3(@click='GoTo("Settings")') Account Settings
              h3(@click='openWatermarkEmbed') Watermarks
              a(href="http://support.flixel.com/")
                h3 Help
            li
              h3(@click='logout()') Log out
      router-link.btn.btn--blue.btn--download(v-if='freePlan', to="products.pricing") Get a Plan
      a.btn.btn--blue.btn--download(v-if='downloadButtoniOS', href='https://itunes.apple.com/ca/app/cinemagraph-pro/id642139481?mt=8') Download
      download-trial-button(
        product='persecond',
        classes='btn btn--blue btn--download',
        copy='Download',
        v-if='downloadButtonPersecond')
      a.btn.btn--blue.btn--download(v-if='downloadButtonBlendeo', href='http://apple.co/Blendeo') Download
      download-trial-button(
        product='pro',
        classes='btn btn--blue btn--download',
        copy='Download',
        v-if='downloadButtonPro')
    .nav__section.nav__menu(v-model="showMobileMenu")
      a.fa.fa-bars#nav--icon(@click="showMobileMenu = true")
      .mobile__nav(v-if="showMobileMenu")
        a.close(v-if="showMobileMenu" @click="showMobileMenu = false")
        .nav__list
          ul
            li.nav__item.nav__item--mobile(v-if="profile")
              a(@click='GoTo("Profile", account.username)') Profile
            li.nav__item.nav__item--mobile(v-if="profile")
              a(@click='GoTo("Settings")') Account Settings
            li.nav__item.nav__item--mobile(v-if="!profile")
              router-link(to="/login/") Sign in
            li.nav__item.nav__item--mobile
              router-link(to="/products/mac/cinemagraph-pro/") Cinemagraph Pro
            li.nav__item.nav__item--mobile
              router-link(to="/products/ios/cinemagraph-pro/") Cinemagraph Pro iOS
            li.nav__item.nav__item--mobile
              router-link(to="/products/ios/blendeo/") Blendeo
            li.nav__item.nav__item--mobile
              router-link(to="/products/mac/persecond/") Persecond
            li.nav__item.nav__item--mobile
              router-link(to="/products/hosting/") Cinemagraph Hosting
            li.nav__item.nav__item--mobile
              router-link(to="/products/pricing/") Pricing
            li.nav__item.nav__item--mobile
              router-link(to="/studios/") Services
            li.nav__item.nav__item--mobile
              router-link(to="/cinemagraphs/") Gallery
            li.nav__item.nav__item--mobile
              router-link(to="/tutorials/") Tutorials
            li.nav__item.nav__item--mobile
              a(href="http://forums.flixel.com") Forums
            li.nav__item.nav__item--mobile
              router-link(to="/case-studies/") Case Studies
            li.nav__item.nav__item--mobile
              a(href="http://blog.flixel.com/") Blog
            li.nav__item.nav__item--mobile
              a(href='http://support.flixel.com/') Help
            li.nav__item.nav__item--mobile(v-if="profile")
              a(@click='logout()') Log out
</template>

<script>
import { headroom } from 'vue-headroom';
import AuthService from 'services/auth.es6.js';
import AccountService from 'services/account.es6.js';
import downloadTrialButton from './downloadTrialButton.vue';
import downloadTrialModal from './downloadTrial.vue';
import watermarkModal from './watermarkWarning.vue';
import router from '../router';
import EventBus from '../eventBus.js';

export default {
  name: 'Navigation',
  data() {
    return {
      account: '',
      profile: '',
      freePlan: false,
      downloadButtoniOS: false,
      showMobileMenu: false,
      downloadButtonPersecond: false,
      downloadButtonBlendeo: false,
      downloadButtonPro: true,
      showNav: true,
      currentPath: '',
      loggedIn: false,
    };
  },
  created() {
    const self = this;
    if (router.currentRoute.name === 'iOS-FCP') {
      this.downloadButtonPro = false;
      this.downloadButtonPersecond = false;
      this.downloadButtonBlendeo = false;
      this.downloadButtoniOS = true;
    } else if (router.currentRoute.name === 'Mac-FPS') {
      this.downloadButtonPro = false;
      this.downloadButtoniOS = false;
      this.downloadButtonBlendeo = false;
      this.downloadButtonPersecond = true;
    } else if (router.currentRoute.name === 'Blendeo') {
      this.downloadButtonPro = false;
      this.downloadButtoniOS = false;
      this.downloadButtonPersecond = false;
      this.downloadButtonBlendeo = true;
    } else {
      this.downloadButtonPersecond = false;
      this.downloadButtoniOS = false;
      this.downloadButtonBlendeo = false;
      this.downloadButtonPro = true;
    }
    // Clears local storage when access token has expired
    AccountService.get()
      .catch(function (data) {
        localStorage.removeItem('profile');
        localStorage.removeItem('account');
      });
    this.profile = JSON.parse(localStorage.getItem('profile'));
    if (JSON.parse(localStorage.getItem('account'))) {
      this.account = JSON.parse(localStorage.getItem('account'));
    }
  },
  mounted() {
    const self = this;
    EventBus.$on('updateNav', function () {
      this.$nextTick(function () {
        self.profile = JSON.parse(localStorage.getItem('profile'));
        self.account = JSON.parse(localStorage.getItem('account'));
      });
    });
    if (router.currentRoute.name === 'Login'
        || router.currentRoute.name === 'Register'
        || router.currentRoute.name === 'ForgotPassword') {
      this.showNav = false;
    } else {
      this.showNav = true;
    }
  },
  watch: {
    '$route': function () {
      this.showMobileMenu = false;
      if (router.currentRoute.name === 'iOS-FCP') {
        this.downloadButtonPro = false;
        this.downloadButtonPersecond = false;
        this.downloadButtonBlendeo = false;
        this.downloadButtoniOS = true;
      } else if (router.currentRoute.name === 'Mac-FPS') {
        this.downloadButtonPro = false;
        this.downloadButtoniOS = false;
        this.downloadButtonBlendeo = false;
        this.downloadButtonPersecond = true;
      } else if (router.currentRoute.name === 'Blendeo') {
        this.downloadButtonPro = false;
        this.downloadButtoniOS = false;
        this.downloadButtonPersecond = false;
        this.downloadButtonBlendeo = true;
      } else {
        this.downloadButtonPersecond = false;
        this.downloadButtoniOS = false;
        this.downloadButtonBlendeo = false;
        this.downloadButtonPro = true;
      }

      if (router.currentRoute.name === 'Login'
          || router.currentRoute.name === 'Register'
          || router.currentRoute.name === 'ForgotPassword') {
        this.showNav = false;
      } else {
        this.showNav = true;
        this.profile = JSON.parse(localStorage.getItem('profile'));
        this.account = JSON.parse(localStorage.getItem('account'));
      }
    },
  },
  methods: {
    // Would be better if this was done using router-link. Can be fixed later.
    GoTo(state, user) {
      // If user is navigating from a profile to their profile
      if (router.currentRoute.name === 'Profile' && state === 'Profile') {
        EventBus.$emit('updateProfileView', user);
      } else {
        this.$router.push({ name: state, params: { username: user } });
      }
    },

    logout() {
      AuthService.logout(this.$router.currentRoute.path);
    },

    openWatermarkEmbed() {
      EventBus.$emit('openWatermarkEmbed');
    },
  },
  components: {
    'download-trial-button': downloadTrialButton,
    'download-trial-modal': downloadTrialModal,
    'watermark-modal': watermarkModal,
    'headroom': headroom,
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Navigation.vue